import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import ContratoService from '../../../services/contrato'
import InfiniteScroll from '../../auth/utils/infiniteScroll';
import Contrato from './contrato';
import Moment from 'moment';


const ListarContratos = () => {

    Moment.locale('pt');
    Moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ]
    });

    async function fetchContratos() {
        await seraQueAcabou();
        const response = await ContratoService.listar({ limit: true, cod_contrato: cod });
        if (response.data.length >= 1) {
            let count = Math.floor(numContratos / 20) + 1
            for (let i = 1; i < count; i++) {
                setContratos([...contratos, ...response.data])
                setCod(response.data[response.data.length-1]["cod_contrato"])
                if (response.data.length < 20) {
                    setAindaTem(false)
                }
            }
        } else {
            setContratos([])
            setVazio(true)
        }
    }

    const [contratos, setContratos] = useState([]);
    const [vazio, setVazio] = useState(false);
    const [cod, setCod] = useState(null);
    const [numContratos, setNumContratos] = useState(null);
    const [aindaTem, setAindaTem] = useState();



    async function fetchContratosIn() {
        await pegaNumContratos();
        const response = await ContratoService.listar();
        if (response.data.length >= 1) {
            setContratos(response.data)
            setVazio(false)
            setCod(response.data[response.data.length-1]["cod_contrato"])
            if (response.data.length == 20) {
                setAindaTem(true)
            } else {
                setAindaTem(false)
            }
        } else {
            setContratos([])
            setVazio(true)
        }
    }

    async function pegaNumContratos() {
        const response = await ContratoService.numContrato({ todas: true })
        setNumContratos(parseInt(response.data))
    }

    const seraQueAcabou = async () => {
        if (contratos.length >= numContratos + 1) {
            setAindaTem(false)
        } else {
            setAindaTem(true)
        }
    }


    useEffect(() => {
        fetchContratosIn();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setContratos={setContratos}
                    setVazio={setVazio}
                    setAindaTem={setAindaTem}
                    fetchContratosIn={fetchContratosIn}
                    contratos={contratos}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <Row xs={1}>
                        {contratos.map((contrato, index) =>
                            <Contrato
                                contrato={contrato}
                                key={index}
                            />
                        )}
                    </Row>
                    {aindaTem ?
                        <Fragment>
                            <p>Carregando mais contratos...</p>
                            <InfiniteScroll Listar={fetchContratos} />
                        </Fragment>
                        : <p>Todos os contratos já foram exibidos :)</p>}
                </Fragment>}
        </Fragment>

    )
}

export default ListarContratos;